import { NfdRecord } from 'api/api-client'

export function isSegmentingUnlocked(nfd: NfdRecord) {
  return nfd?.properties?.internal?.segmentLocked === '0'
}

export function isSegmentingLocked(nfd: NfdRecord) {
  return !isSegmentingUnlocked(nfd)
}
